import { render, staticRenderFns } from "./BannerPrincipal.vue?vue&type=template&id=d6ebd57e"
import script from "./BannerPrincipal.vue?vue&type=script&lang=js"
export * from "./BannerPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports